export default __webpack_public_path__ + "static/media/404.ed676656.png";